export default function requestAuthorization(email, password) {
    return {
        payload: {
            email,
            password,
        },
        type: requestAuthorization.type,
    };
}

requestAuthorization.type = 'REQUEST_AUTHORIZATION';
